<div class="coworker-home-container" *ngIf="!showCancelBookingSection">
  <div class="header">
    <h3>{{ "coworker.bookings.title" | translate }}</h3>
  </div>
  <div class="container">
    <div *ngIf="!bookingList.length" class="empty-booking">
      <img [src]="getCalendarIcon" alt="" />
      <span>{{ "coworker.bookings.no-bookings" | translate }}</span>
    </div>
    <div *ngIf="bookingList.length">
      <div class="booking-list" *ngIf="bookingListAfter.length">
        <span class="title">
          {{ "coworker.bookings.bookings-active" | translate }}
        </span>
        <coworker-booking-card *ngFor="let booking of bookingListAfter" [booking]="booking"
          [bookingStates]="bookingStates" (showCancel)="showCancel($event)"></coworker-booking-card>
      </div>
      <div class="booking-list" *ngIf="bookingListPast.length">
        <span class="title">
          {{ "coworker.bookings.bookings-past" | translate }}
        </span>
        <coworker-booking-card *ngFor="let booking of bookingListPast" [booking]="booking"
          [bookingStates]="bookingStates"></coworker-booking-card>
      </div>
    </div>
  </div>
  <div class="tabs">
    <cowing-tabs [active]="EActiveTab.Booking"></cowing-tabs>
  </div>
</div>

<div *ngIf="showCancelBookingSection" class="cancel-section">
  <div class="head" (click)="showCancel()">
    <img [src]="getClose" alt="" />
  </div>
  <div class="title">
    {{ "coworker.bookings.cancel-title" | translate }}
  </div>
  <div class="description" *ngIf="!show24CancelMessage">
    {{ "coworker.bookings.cancel-description" | translate }}
  </div>
  <div class="description" *ngIf="show24CancelMessage">
    {{ "coworker.bookings.cancel-description-24" | translate }}
  </div>
  <div class="actions">
    <div>
      <cowing-button [label]="'general.close' | translate" [type]="EButtonType.RoundedSecondary" [iconShow]="false"
        (event)="showCancel()">
      </cowing-button>
    </div>
    <div>
      <cowing-button [label]="'general.cancel' | translate" [type]="EButtonType.Primary" [iconShow]="false"
        (event)="cancelBooking()">
      </cowing-button>
    </div>
  </div>
</div>